import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Seo } from "../components/Seo";
import { Nav } from "../components/landing/Nav";
import { Footer } from "../components/landing/Footer";
import { ManagerRegister } from "../components/ManagerRegister";

const DirectoryPage = () => (
  <div className="bg-navy text-ink min-h-screen antialiased" data-testid="directory-page">
    <Seo
      title="Australian Private Credit Manager Directory"
      description="Register of 60+ Australian private credit managers and non-bank lenders — strategy classifications, AFSL references and domains. Public facts only, no ratings."
      path="/directory"
    />
    <Nav />
    <main className="max-w-6xl mx-auto px-6 py-16">
      <span className="text-xs font-mono text-cy uppercase tracking-widest">DIRECTORY INDEX</span>
      <h1 className="font-display text-4xl md:text-6xl text-white uppercase mt-2">
        Australian Private Credit <span className="text-cy">Manager Register</span>
      </h1>
      <p className="text-base md:text-lg text-mut leading-relaxed mt-4 max-w-3xl">
        A filterable register of Australian private credit managers and non-bank lenders, listed by public
        facts only: name, strategy classification, AFSL reference where verified, and domain. No ratings, no
        rankings, no endorsements.
      </p>

      <div className="mt-10">
        <ManagerRegister />
      </div>

      <div className="mt-8 p-6 rounded-xl bg-surface border border-line font-mono text-xs">
        <div className="text-cy font-bold flex items-center gap-2">
          <ShieldCheck className="w-4 h-4" /> DIRECTORY REGULATION NOTICE
        </div>
        <p className="text-mut mt-2 leading-relaxed font-body">
          Listings contain public licensing and strategy descriptors only, and are not endorsements.
          privatecredit.com.au does not accept placement fees, assign proprietary credit ratings, or endorse
          fund returns. Confirm licence details on ASIC Connect before relying on them. Managers who would like
          their entry corrected can email{" "}
          <a href="mailto:info@grow-capital.com.au" className="text-cy hover:underline">
            info@grow-capital.com.au
          </a>
          .
        </p>
      </div>

      <div className="mt-8">
        <Link
          to="/explainers"
          data-testid="directory-explainers-link"
          className="inline-block px-6 py-3 rounded border border-line bg-surface text-white font-mono text-xs hover:border-cy/50 transition-colors"
        >
          READ THE EXPLAINERS &rarr;
        </Link>
      </div>
    </main>
    <Footer />
  </div>
);

export default DirectoryPage;
